@if (config) {
  <app-modal [removeInlinePadding]="config.step === FORM_STEP.Three">
    <h2 class="header">{{ config.modalHeader }}</h2>

    <form [formGroup]="form" class="form main">
      @if (config.meta && config.meta.isArray) {
        <ng-container
          formArrayName="travelers"
          *ngFor="let price of formArray.controls; let i = index"
        >
          <div class="traveler">
            <div class="traveler__header">
              @if (config.title) {
                <h3>{{ config.title }} {{ i + 1 }}</h3>
              }
              @if (config.actions?.["deleteField"] && i > 0) {
                <button
                  (click)="removeTraveler(i)"
                  class="traveler__btn-delete"
                >
                  <img
                    [src]="config.actions?.['deleteField']?.icon"
                    alt="delete traveler"
                  />
                </button>
              }
            </div>
            <div [formGroupName]="i" class="traveler__controls" #form>
              @for (control of config.fields; track $index) {
                @switch (control.type) {
                  @case (FIELD_TYPE.MASKED_TYPE) {
                    <div
                      class="input-container"
                      [class.input-invalid]="ctrlValidity(control.name, i)"
                    >
                      <input
                        class="input-container__input"
                        type="text"
                        [id]="control.name"
                        [placeholder]="control.placeholder"
                        [formControlName]="control.name"
                        [mask]="control.maskConfig?.mask"
                        [showMaskTyped]="
                          control.maskConfig?.showMaskTyped || null
                        "
                        [validation]="control.maskConfig?.validation || null"
                        [thousandSeparator]="
                          control.maskConfig?.thousandSeparator || ''
                        "
                        [decimalMarker]="'.'"
                        [placeHolderCharacter]="
                          control.maskConfig?.placeholderCharacter || null
                        "
                        [leadZeroDateTime]="
                          control.maskConfig?.leadZeroDateTime || null
                        "
                        [dropSpecialCharacters]="
                          control.maskConfig?.dropSpecialCharacters || null
                        "
                      />
                      <label
                        [for]="control.name"
                        class="input-container__label"
                      >
                        {{ control.label }}
                      </label>
                      @if (ctrlValidity(control.name, i)) {
                        <div class="error-message">
                          {{ generateTravelerErrorMessage(control.name, i) }}
                        </div>
                      }
                    </div>
                  }
                  @case (FIELD_TYPE.TEXT) {
                    <div class="input-container">
                      <input
                        class="input-container__input"
                        type="text"
                        [id]="control.name"
                        [formControlName]="control.name"
                      />

                      <label
                        [for]="control.name"
                        class="input-container__label"
                      >
                        {{ control.label }}
                      </label>
                    </div>
                  }
                  @case (FIELD_TYPE.NUMBER) {
                    <div
                      class="input-container"
                      [class.input-invalid]="ctrlValidity(control.name, i)"
                    >
                      <input
                        class="input-container__input"
                        type="number"
                        [id]="control.name"
                        [placeholder]="control.placeholder"
                        [formControlName]="control.name"
                      />
                      <label
                        [for]="control.name"
                        class="input-container__label"
                      >
                        {{ control.label }}
                      </label>
                      @if (ctrlValidity(control.name, i)) {
                        <div class="error-message">
                          {{ generateTravelerErrorMessage(control.name, i) }}
                        </div>
                      }
                    </div>
                  }
                  @case (FIELD_TYPE.DATE_MASKED) {
                    <div
                      class="input-container"
                      [class.input-invalid]="ctrlValidity(control.name, i)"
                    >
                      <input
                        class="input-container__input"
                        type="text"
                        [id]="control.name"
                        [formControlName]="control.name"
                        [placeholder]="control.placeholder"
                        [mask]="control.maskConfig?.mask || ''"
                        [showMaskTyped]="
                          control.maskConfig?.showMaskTyped || null
                        "
                        [validation]="control.maskConfig?.validation || null"
                        [placeHolderCharacter]="
                          control.maskConfig?.placeholderCharacter || null
                        "
                        [leadZeroDateTime]="
                          control.maskConfig?.leadZeroDateTime || null
                        "
                      />
                      <label
                        [for]="control.name"
                        class="input-container__label"
                      >
                        {{ control.label }}
                      </label>
                      @if (ctrlValidity(control.name, i)) {
                        <div class="error-message">
                          {{ generateTravelerErrorMessage(control.name, i) }}
                        </div>
                      }
                    </div>
                  }
                }
              }
            </div>
          </div>
        </ng-container>
        @if (config.meta.allowAddControls) {
          <div class="action-btn-group">
            <div class="action-btn-group__add-control">
              <button
                (click)="addTraveler()"
                type="button"
                class="action-btn-group__add-control__button"
              >
                <img
                  [src]="config.actions?.['addField']?.icon"
                  alt="add traveler"
                  class="action-btn-group__add-control__icon"
                />

                {{ config.actions?.["addField"]?.text }}
              </button>
            </div>
            <app-button
              [data]="buttonData"
              [disabled]="isFormInvalid"
              class="action-btn-group__next-step"
              (click)="navigateToNextStep()"
            ></app-button>
          </div>
        }
      } @else {
        @if (isPaymentCompleteCtrl) {
          <div class="payment-complete">
            <label for="float-label" class="payment-complete__label">
              Payments Left
              <app-tooltip
                [text]="isPaymentCompleteTooltip"
                class="payment-complete__label__icon"
              ></app-tooltip>
            </label>
            <p-dropdown
              class="dropdown"
              [options]="isPaymentCompleteData"
              [formControl]="isPaymentCompleteCtrl"
              optionLabel="name"
              inputId="float-label"
              [placeholder]="'isComplete'"
              (onChange)="updateDepositVisibility($event)"
            />
          </div>
        }

        @for (control of config.fields; track $index) {
          @switch (control.type) {
            @case (FIELD_TYPE.MASKED_TYPE) {
              <div>
                @if (control.name === "payment") {
                  <label [for]="control.name" class="label-tooltip">
                    Deposit Amount
                    <app-tooltip
                      [text]="control.tooltip!"
                      class="label-tooltip__icon"
                    ></app-tooltip>
                  </label>
                }
                <div
                  class="input-container"
                  [class.input-invalid]="ctrlValidityTopmost(control.name)"
                >
                  <input
                    class="input-container__input"
                    type="text"
                    [id]="control.name"
                    [placeholder]="control.placeholder"
                    [formControlName]="control.name"
                    [mask]="control.maskConfig?.mask"
                    [showMaskTyped]="control.maskConfig?.showMaskTyped || null"
                    [validation]="control.maskConfig?.validation || null"
                    [thousandSeparator]="
                      control.maskConfig?.thousandSeparator || ''
                    "
                    [decimalMarker]="'.'"
                  />
                  <label [for]="control.name" class="input-container__label">
                    {{ control.label }}
                  </label>
                  @if (ctrlValidityTopmost(control.name)) {
                    <div class="error-message">
                      {{ generateTopmostCtrlErrorMessage(control.name) }}
                    </div>
                  }
                </div>
              </div>
            }
            @case (FIELD_TYPE.TEXT) {
              <input
                type="text"
                [placeholder]="control.placeholder"
                [formControlName]="control.name"
              />
            }
            @case (FIELD_TYPE.NUMBER) {
              <div
                class="input-container"
                [class.input-invalid]="ctrlValidityTopmost(control.name)"
              >
                <input
                  class="input-container__input"
                  type="number"
                  [id]="control.name"
                  [placeholder]="control.placeholder"
                  [formControlName]="control.name"
                />
                <label [for]="control.name" class="input-container__label">
                  {{ control.label }}
                </label>
                @if (ctrlValidityTopmost(control.name)) {
                  <div class="error-message">
                    {{ generateTopmostCtrlErrorMessage(control.name) }}
                  </div>
                }
                @if (ctrlValidityTopmost(control.name)) {
                  <div class="error-message">
                    {{ generateTopmostCtrlErrorMessage(control.name) }}
                  </div>
                }
              </div>
            }
            @case (FIELD_TYPE.DATE_RANGE) {
              <ng-container *ngTemplateOutlet="days"></ng-container>
              <app-datepicker
                [isRange]="true"
                [formControlName]="control.name"
                [minDateInput]="control.minDate"
              ></app-datepicker>
            }
            @case (FIELD_TYPE.DATE_SINGLE) {
              <div>
                <ng-container *ngTemplateOutlet="days"></ng-container>

                <label [for]="control.name" class="label-tooltip">
                  Deposit Date
                  <app-tooltip
                    [text]="control.tooltip!"
                    class="label-tooltip__icon"
                  ></app-tooltip>
                </label>
                <app-datepicker
                  [formControlName]="control.name"
                  [maxDateInput]="control.maxDate"
                ></app-datepicker>
              </div>
            }
            @case (FIELD_TYPE.SELECT) {
              <app-dropdown-list
                [formControlName]="control.name"
                [label]="control.placeholder"
              ></app-dropdown-list>
            }
          }
        }
      }
    </form>
    <div class="form__footer footer">
      <button class="form__footer__reset" (click)="resetForm()">Reset</button>
      <app-button
        [data]="buttonData"
        (click)="navigateToNextStep()"
        [disabled]="isFormInvalid"
      ></app-button>
    </div>
  </app-modal>
}

<ng-template #days>
  @if (config.step === FORM_STEP.Two || config.step === FORM_STEP.Four) {
    <div class="extras">
      @for (day of weekdays; track $index) {
        <p [style.fontSize.px]="14" class="extras__cell">{{ day }}</p>
      }
    </div>
  }
</ng-template>

<p-toast></p-toast>
